document.addEventListener('alpine:init', () => {
    Alpine.data('documentManager', () => ({
        showModal: false,
        loading: false,
        error: null,
        previewUrl: null,
        previewFilename: '',
        previewExtension: '',
        openPreview(fileId, filename) {
            this.showModal = true;
            this.loading = true;
            this.error = null;
            this.previewUrl = null;
            this.previewFilename = filename;
            this.previewExtension = filename.split('.').pop().toLowerCase();

            const organizationId = this.$root.dataset.organizationId;
            fetch(`/admin/organization/${organizationId}/documents/${fileId}/preview`)
                .then(response => {
                    if (!response.ok) throw new Error('プレビューの取得に失敗しました');
                    return response.json();
                })
                .then(data => {
                    this.previewUrl = data.url;
                    this.previewExtension = data.extension;
                    this.loading = false;
                })
                .catch(err => {
                    this.error = err.message || 'プレビューの取得に失敗しました';
                    this.loading = false;
                });
        },
        closePreview() {
            this.showModal = false;
            this.previewUrl = null;
            this.error = null;
        }
    }));
});
